import { useQuery } from 'react-query'
import {
  getMomiTelemetryMeasurement,
  MomiTelemetryFilter,
} from '../service/momiTelemetryAPI'

export function useMomiTelemetryMeasurement(
  momiUuid: string | undefined,
  measurement: string,
  filter: MomiTelemetryFilter
) {
  return useQuery({
    queryKey: ['momi-telemetry', momiUuid, measurement, filter],
    queryFn: () =>
      getMomiTelemetryMeasurement(momiUuid as string, measurement, filter),
    enabled: Boolean(momiUuid && measurement),
  })
}
